export default __webpack_public_path__ + "static/image9-34704d17c6ed38f1295f018425fd17d4.gif";